import clientProfile from '@/locales/en/clientProfile/clientProfile.locales';

export default {
    ...clientProfile,
};
